module.exports = __webpack_public_path__ + "static/media/mw.baf27f86.svg";